import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;

  > div {
    background: var(--white-darker);
    border-radius: 100px;
    height: 200px;
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  h2 {
    color: var(--primary);
    font-size: 36px;
    margin-bottom: 10px;
  }

  p {
    font-size: 16px;
    color: var(--gray-7);
    text-align: center;
  }
`;
